/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  SkillEfficacyRegressionSignal,
  SkillEfficacyRegressionSignal$inboundSchema,
} from "./skillefficacyregressionsignal.js";
import {
  SkillInsightMetrics,
  SkillInsightMetrics$inboundSchema,
} from "./skillinsightmetrics.js";
import {
  SkillVersionInsight,
  SkillVersionInsight$inboundSchema,
} from "./skillversioninsight.js";

export type SkillEfficacyInsight = {
  metrics: SkillInsightMetrics;
  /**
   * The current skill version's efficacy comparison using the server suggestion policy.
   */
  regressionSignal?: SkillEfficacyRegressionSignal | undefined;
  skillId: string;
  versions: Array<SkillVersionInsight>;
};

/** @internal */
export const SkillEfficacyInsight$inboundSchema: z.ZodMiniType<
  SkillEfficacyInsight,
  unknown
> = z.pipe(
  z.object({
    metrics: SkillInsightMetrics$inboundSchema,
    regression_signal: z.optional(SkillEfficacyRegressionSignal$inboundSchema),
    skill_id: z.string(),
    versions: z.array(SkillVersionInsight$inboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      "regression_signal": "regressionSignal",
      "skill_id": "skillId",
    });
  }),
);

export function skillEfficacyInsightFromJSON(
  jsonString: string,
): SafeParseResult<SkillEfficacyInsight, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SkillEfficacyInsight$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SkillEfficacyInsight' from JSON`,
  );
}
